<dx-box width="100%" height="100%" class="job-detail-container" direction="col">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <div class="column-container">
                Overall Job Description
                <dx-text-area [height]="70" [(value)]="workOrderInfo.jobDescription"></dx-text-area>
            </div>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <dx-box width="100%" height="100%" direction="col" class="box-container">
                <dxi-item baseSize="auto">
                    <div *dxTemplate>
                        <dx-toolbar width="100%" class="toolbar-container">
                            <dxi-item location="before">
                                <div *dxTemplate>Work Order Line Items</div>
                            </dxi-item>
                            <dxi-item location="after">
                                <div *dxTemplate>
                                    <dx-button
                                        type="default"
                                        text="Add Line Item"
                                        hint="Add Line Item"
                                        [icon]="iconPlus"
                                        (onClick)="onAddLineItemClick()"
                                    ></dx-button>
                                </div>
                            </dxi-item>
                        </dx-toolbar>
                    </div>
                </dxi-item>
                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <dx-data-grid
                            #lineItemGrid
                            ccAddNewRow
                            width="100%"
                            height="100%"
                            keyExpr="id"
                            [dataSource]="workOrderInfo.lineItems"
                            [highlightChanges]="true"
                            [repaintChangesOnly]="true"
                            [allowColumnReordering]="true"
                            [allowColumnResizing]="true"
                            [showBorders]="true"
                            [showColumnLines]="true"
                            [showRowLines]="true"
                            (onRowUpdated)="onRowUpdated($event)"
                            (onContentReady)="onEditorContentReady($event)"
                            (onAddNewRow)="onAddLineItemClick()"
                        >
                            <dxo-editing
                                mode="cell"
                                refreshMode="full"
                                selectTextOnEditStart="true"
                                [allowUpdating]="true"
                                [useIcons]="true"
                            ></dxo-editing>
                            <dxi-column
                                cellTemplate="actionTemplate"
                                caption="Action"
                                alignment="center"
                                [allowEditing]="false"
                                [showEditorAlways]="false"
                                [width]="70"
                            ></dxi-column>
                            <dxi-column
                                dataField="description"
                                dataType="string"
                                caption="Description"
                                headerCellTemplate="mandatoryCellTemplate"
                                [allowEditing]="true"
                            ></dxi-column>
                            <dxi-column
                                dataField="serviceCode"
                                dataType="string"
                                caption="Service Code"
                                headerCellTemplate="mandatoryCellTemplate"
                                [allowEditing]="true"
                            >
                                <dxo-lookup
                                    [dataSource]="workOrderEditor.serviceCodeList"
                                    displayExpr="displayText"
                                    valueExpr="key"
                                ></dxo-lookup>
                            </dxi-column>
                            <dxi-column
                                dataField="amount"
                                dataType="number"
                                caption="Amount"
                                [editorOptions]="{ min: 0 }"
                                [format]="currencyFormat"
                                [allowEditing]="true"
                            ></dxi-column>

                            <div *dxTemplate="let header of 'mandatoryCellTemplate'">
                                {{ header.column.caption }}
                                <sup class="cc-text-required">*</sup>
                            </div>

                            <div *dxTemplate="let d of 'actionTemplate'">
                                <i
                                    class="cc-1-5x icon-content cc-red-icon"
                                    title="Delete"
                                    [ngClass]="iconDelete"
                                    (click)="onDeleteClick(d.data)"
                                ></i>
                            </div>
                        </dx-data-grid>
                    </div>
                </dxi-item>
            </dx-box>
        </div>
    </dxi-item>
</dx-box>
